<div id="main-wrapper">
    <app-side-bar></app-side-bar>
    <div class="page-wrapper">
        <div class="container-fluid">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
